module.exports = __webpack_public_path__ + "static/media/Icon_Azul2.086da3a0.svg";